import React from 'react'
import { DatePicker } from 'rsuite'
import 'rsuite/DatePicker/styles/index.css';


function DatePickerField({ format = "yyyy-MM-dd",placeholder = "yyyy-mm-dd", oneTap = true, value,label = "", ...props }) {
    return (
        <div>
            <DatePicker
                className='w-100'
                placeholder={placeholder}
                format={format}
                oneTap={oneTap}
                label={label}
                {...props}
                value={value}
            />
        </div>
    )
}

export default DatePickerField;